import httpClient from '@/http-client'

export const get = (Options = {}) => {
	return httpClient
		.get('/api/comments', Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const store = data => {
	return httpClient
		.post('/api/comments', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
	return httpClient
		.get(`/api/comments/${id}`, Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const update = data => {
	return httpClient
		.put(`/api/comments/${data.comment_id}`, data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
	return httpClient
		.delete(`/api/comments/${id}`)
		.then(response => Promise.resolve(response.data))
}

export default {
	get,
	find,
	store,
	update,
	destroy
}
